import { useSelector } from "react-redux";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import { DocumentViewer } from "../../../components/DocumentViewer";
import { selectDocument } from "../../../store/documentShow/selectors/selectDocument";
export const DocumentInfo: React.FC = () => {
  const document = useSelector(selectDocument);

  return <DocumentViewer document={document}></DocumentViewer>;
};
